import React, { useState } from "react";
import { auth } from '../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import logo from '../../assets/logo/logo.png';

const ForgotPassword = () => {

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const actionCodeSettings = {
    // url: "http://localhost:3000/reset-password", for local testing
    url: "https://arthurconnects.com/reset-password", // for production
    handleCodeInApp: true, // Important for custom handling
  };

  const getForgotPasswordError = (code) => {
    switch (code) {
        case "auth/invalid-email":
            return "Invalid email address format.";
        case "auth/user-not-found":
            return "No account found with this email.";
        case "auth/too-many-requests":
            return "Too many requests. Please try again later.";
        default:
            return "Failed to send reset link. Please try again.";
    }
};

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email.trim(), actionCodeSettings);
            setSuccess("Password reset email sent! Check your inbox. Please check your spam or junk folder if you don't see it in your inbox.");
        } catch (err) {
            setError(getForgotPasswordError(err.code));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', paddingTop: 80, paddingBottom: 40 }}>
            <div className="header" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)',
                color: '#fff',
                padding: '12px 20px',
                zIndex: 1001,
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                borderBottom: '2px solid #4a90e2',
                flexWrap: 'wrap',
            }}>
                {/* Logo and Title */}
                <div style={{
                    display: 'flex',
                    // alignItems: 'center',
                    gap: '16px',
                    margin: '0 auto'
                }}>
                    <img src={logo} alt="logo" width="55px" style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        border: '2px solid #4a90e2',
                        backgroundColor: '#ffffff'
                    }} />
                    <h1 style={{
                        color: "#ffffff",
                        margin: 0,
                        fontSize: '1.8rem',
                        fontWeight: '700',
                        // textAlign: 'center',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                        letterSpacing: '1px',
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                    }}>
                        ARTHUR APPLICATION SYSTEM (AAS)
                    </h1>
                </div>
            </div>
            <br />
            <div className="login-container" style={{ maxWidth: 400, margin: "40px auto", padding: 24, borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", background: "#fff" }}>
                <h1 style={{ textAlign: "center", marginBottom: 24 }}>Reset Password</h1>
                {error && (
                    <div style={{ color: 'red', marginBottom: 12, textAlign: 'center' }}>{error}</div>
                )}
                {success && (
                    <div style={{ color: 'green', marginBottom: 12, textAlign: 'center' }}>{success}</div>
                )}
                <form className="login-form" onSubmit={handleForgotPassword} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    <label style={{ fontWeight: 500 }}>
                        email
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
                            placeholder="Enter your email"
                        />
                    </label>

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, marginBottom: 8 }}>
                        <a href="/login" style={{ fontSize: 14, color: '#007bff', textDecoration: 'none' }}>Login</a>
                        <a href="/create-account" style={{ fontSize: 14, color: '#007bff', textDecoration: 'none' }}>Create account</a>
                    </div>
                    <button type="submit" style={{ padding: 10, borderRadius: 6, background: "#007bff", color: "#fff", fontWeight: 600, border: "none", marginTop: 8, display: loading ? 'none' : 'block' }}>send reset password link</button>
                </form>
                {loading && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <div className="loader"></div>
                    </div>
                )}
            </div>
            <footer style={{ textAlign: 'center', marginTop: 40, color: '#fff' }}>
                &copy; {new Date().getFullYear()} Arthur International Agency. All rights reserved.
            </footer>
        </div>
    );
};

export default ForgotPassword;